import { type ISbRichtext } from '@storyblok/react'
import { type SignUpStoryblok } from '~/types/generated'
import { type SignUpFormProps } from './SignUpForm.interface'
import { type RichTextProps } from '../RichText/RichText.interface'
import { type FormCategoryProps } from '~/types'

export const mapRichText = (input: ISbRichtext | undefined): RichTextProps => {
  if (!input) {
    return {
      richtext: {
        type: 'doc'
      }
    }
  }

  return {
    richtext: input
  }
}
interface FormTypes extends SignUpStoryblok {
  categories: FormCategoryProps[];
}

export const mapSignUpForm = (story: FormTypes): SignUpFormProps => {
  const button = story.button?.[0]
  return {
    businessTitle: story.businessDetailHeading,
    businessDescription: mapRichText(story.businesDetailDescription),
    categories: story.categories.map((category) => ({
      id: category.id,
      label: category.displayName,
      value: category.name,
      options: category.subCategories.map((option) => ({
        id: option.id,
        label: option.name,
        value: option.value
      })),
      pluralisationText: category?.pluralisationText
    })),
    categoriesHeading: story.categoriesHeading,
    categoriesDescription: mapRichText(story.categoriesDescription),
    photosHeading: story.photosHeading,
    photosDescription: mapRichText(story.photosDescription),
    contactDetailsHeading: story.contactDetailsHeading,
    contactDetailsDescription: mapRichText(story.contactDetailsDescription),
    submitButton: {
      children: button?.linkText
    }
  }
}
